<template lang="pug">
  section#works
    .section-title
      p
        span experi
        span ments.
    .work-list
      router-link(:to="$route.path + '/' + work.workTitle.en.toLowerCase().replace(/ /g, '-').replace(/\\?/g, '') " class="link" v-for="work in works" :key="work.id")
        WorkBox(:work="work")
    transition(name="work-detail")
      WorkDetail(:work="nowWork" :screenSize="screenSize" v-if="Object.keys(nowWork).length !== 0 && $route.path.split('/').length > 2")
</template>

<script>
import WorkBox from './WorkBox'
import WorkDetail from './WorkDetail'

export default {
  name: 'Works',
  components: { WorkBox, WorkDetail },
  props: ['screenSize'],
  data () {
    return {
      works: [
        {
          id: 15,
          workType: "experiment",
          workTitle: {
            en: "Creative Coding"
          },
          workInfo: "//digital art",
          workImg: require("@/assets/images/creative-coding/cover.png"),
          workDetail: {
            info: [
              "Tools: webgl / glsl / p5.js ",
              "",
              "主要使用webgl glsl fragment shader作為載體，以數學作為畫筆進行生成式藝術創作。",
              "",
              "> <a href='https://www.shadertoy.com/user/changwenhan' target='_blank'>shadertoy profile</a>",
              "> <a href='https://openprocessing.org/user/322254' target='_blank'>open processing profile</a>",
            ],
            photos: [
              {
                imgs: [
                  {
                    type: "video",
                    data: require("@/assets/images/creative-coding/v8.mp4")
                  },
                  {
                    type: "video",
                    data: require("@/assets/images/creative-coding/v9.mp4")
                  }
                ],
              },
              {
                imgs: [
                  {
                    type: "video",
                    data: require("@/assets/images/creative-coding/v1.mp4")
                  },
                  {
                    type: "video",
                    data: require("@/assets/images/creative-coding/v3.mp4")
                  },
                ],
              },
              {
                imgs: [
                  {
                    type: "video",
                    data: require("@/assets/images/creative-coding/v2.mp4")
                  },
                  {
                    type: "video",
                    data: require("@/assets/images/creative-coding/v4.mp4")
                  },
                  {
                    type: "video",
                    data: require("@/assets/images/creative-coding/v5.mp4")
                  }
                ],
              },
              {
                imgs: [
                  {
                    type: "video",
                    data: require("@/assets/images/creative-coding/v6.mp4")
                  },
                  {
                    type: "video",
                    data: require("@/assets/images/creative-coding/v7.mp4")
                  }
                ],
              },
            ],
          }
        },
        {
          id: 1,
          workType: "experiment",
          workTitle: {
            en: "RELAY & MAGIC"
          },
          workInfo: "//digital art",
          workImg: require("@/assets/images/experiment1/cover.png"),
          workDetail: {
            info: [
              "Tools: Samsung Gear 360 / Adobe Premiere ",
              "",
              "\"RELAY\" and \"MAGIC\" are two 360-degree panoramic video based on the virtual image in the mirror. It is recommended to watch in VR mode on YouTube.",
              "\"RELAY\" makes viewers to shuttle back and forth between mirrors in virtual reality, breaking the boundaries between reality and virtuality. \"MAGIC\" uses post-editing to create effects in panoramic video, such as time stillness, reverse, split, etc., and create an amazing mirror tour through the camera movement.",
              "These two works mainly explore the possibility of extending and recreating the space in virtual reality using the feature of specular reflection and panoramic photography.",
              "",
              "《RELAY》與《MAGIC》為兩件以鏡子中之虛像作為出發點的360度全景錄像作品，推薦於YouTube上以VR模式觀看。",
              "《RELAY》使觀者在虛擬實境中來回穿梭於鏡中鏡外，將現實與非現實的界限打破，《MAGIC》則利用剪接後製在全景錄像中製造非現實的特效，如時間靜止、倒轉、分身等，並透過鏡頭移動打造虛實交錯的鏡中之旅。",
              "此兩件作品主要在探討現實空間於虛擬實境中延展與再創造的可能性，利用鏡面反射與全景攝影的特性，以現實作為基礎製造出了鏡中空間。",
              "",
              "> <a href='https://www.youtube.com/watch?v=4UgiRWRyGkI' target='_blank'>RELAY</a>",
              "> <a href='https://www.youtube.com/watch?v=__ZVqvxT0S4' target='_blank'>MAGIC</a>",
            ],
            photos: [
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/experiment1/1.png")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/experiment1/2.png")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/experiment1/3.png")
                  }
                ]
              },
            ],
          }
        },
        {
          id: 2,
          workType: "experiment",
          workTitle: {
            en: "glitch_me"
          },
          workInfo: "//digital art",
          workImg: require("@/assets/images/experiment2/cover.png"),
          workDetail: {
            info: [
              "Tools: chrome extension",
              "",
              "\"glitch_me\" is a self-made Google Chrome extension. Users can click on the icon on any website page, which will cause the page to start to appear abnormally broken and infinitely recursively their own screenshots, producing art from chaos and destruction.",
              "",
              "《glitch_me》是一個自製Google Chrome擴充套件，使用者可以於任何網站頁面下點擊圖示，便會使網頁畫面開始出現異常的破圖與無限遞迴的自身截圖，從混亂與破壞中產出不諧和的美。"
            ],
            photos: [
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/experiment2/1.png")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/experiment2/2.png")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/experiment2/3.png")
                  }
                ]
              },
            ],
            videos: [
              {
                img: require("@/assets/images/experiment2/cover.png"),
                id: "WFdlwde4biI"
              }
            ]
          },
        },
        {
          id: 9,
          workType: "experiment",
          workTitle: {
            en: "Control & Reality"
          },
          workInfo: "//digital art",
          workImg: require("@/assets/images/experiment3/cover.png"),
          workDetail: {
            info: [
              "Media: html5 / aframe.js / socket.io / mobile phone / television",
              "",
              "\"Control & Reality\" is a performance art work that \"controls\" viewers through virtual reality and transforms their experiences into live performances.",
              "\"Control & Reality\" works in the form of a virtual reality device and a TV screen. After the audience wears the device, a fun and light rhythm game will be played in the virtual reality. Audience will rhythmic moving sight and steering by music beats and screen instructions in a soft healing world. However at the same time, the black and boring finger pointing screen is displayed on the TV screen behind the audience. In the view of outsiders, the audience seems to be controlled, following the instructions in the screen and performing mechanically step by step.",
              "",
              "《Control & Reality》是一個透過虛擬實境「控制」觀眾並將其之體驗轉化成為現場演出的行為藝術作品。",
              "《Control & Reality》作品形式為一個虛擬實境裝置與電視螢幕，觀眾戴上裝置後，會在虛擬實境中進行一場有趣輕快的節奏遊戲，在柔和療癒的世界裡跟著音樂節拍與畫面指示有節奏的移動視線與轉向。然而該觀眾身後的電視螢幕中顯示的卻是黑白且深沈無趣的手指指示畫面，在外人眼中看來，該觀眾就像是被控制一般，遵循螢幕中的指令並一步步機械式的執行。"
            ],
            photos: [
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/experiment3/1.png")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "video",
                    data: require("@/assets/images/experiment3/v1.mp4")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "video",
                    data: require("@/assets/images/experiment3/v2.mp4")
                  }
                ]
              },
            ],
            videos: [
              {
                img: require("@/assets/images/experiment3/cover.png"),
                id: "4RLUOtArz5Y"
              }
            ]
          }
        },
        {
          id: 4,
          workType: "experiment",
          workTitle: {
            en: "Typer"
          },
          workInfo: "//web",
          workImg: require("@/assets/images/experiment4/cover.png"),
          workDetail: {
            info: [
              "Tools: html5 / matter.js",
              "",
              "When user is typing in \"typer\", the screen will spray out alphabets and stack on each other by physics engine.",
              "",
              "當使用者在《Typer》中敲擊電腦鍵盤，便會於畫面上噴出對應的英文字元，在物理引擎的交互作用中堆積於畫面上。",
              "",
              "> <a href='https://cwh-typer.surge.sh/' target='_blank'>website</a>"
            ],
            photos: [
              {
                imgs: [
                  {
                    type: "video",
                    data: require("@/assets/images/experiment4/v1.mp4")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/experiment4/1.png")
                  }
                ]
              },

            ]
          }
        },
        {
          id: 10,
          workType: "experiment",
          workTitle: {
            en: "Who is murderer?"
          },
          workInfo: "//interactive film",
          workImg: require("@/assets/images/experiment5/cover.jpg"),
          workDetail: {
            info: [
              "Role: overall design, program dev",
              "Media: 360 degree image & video / virtual reality device / html5 / socket.io / Unity Engine / computer",
              "",
              "\"Who is murderer?\" is an interactive virtual reality film that requires two people to work together and help each other. The story describes an amnesia man who woke up from a coma in the uninhabited building in the middle of the night. He found a female deceased next to him. Through the help of friend of the deceased on the phone, he started to investigate the clues of the whole case and memory.",
              "When \"Who is murderer?\" is experienced, one person needs to wear a virtual reality device to devote himself to the amnesia man to carry out the movement and investigation on the spot. And the other person devote his friend, using the map in front of the computer screen and obtaining clues. Thay need to exchange clues and opinions through dialogue to help each other complete the experience of the entire film.",
              "",
              "《Who is murderer?》是一個需雙人同時進行並互相協助來體驗的互動式VR電影作品。劇情描述在半夜無人的教學大樓從昏迷中醒來的失憶男人發現身旁有個女性死者，透過電話另一頭死者友人的協助，一起調查整起案件與記憶的線索。",
              "《Who is murderer?》體驗時，需一人戴上虛擬實境裝置投身於失憶男人進行現場的移動與調查，另一人則扮演死者友人在電腦螢幕前使用地圖並獲取搜集線索的詳細敘述，兩人透過對話交換線索與意見，互相協助以完成整個作品的體驗。"
            ],
            photos: [
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/experiment5/1.png")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/experiment5/2.png")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/experiment5/3.png")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/experiment5/4.png")
                  }
                ]
              },
            ],
            videos: [
              {
                img: require("@/assets/images/experiment5/1.png"),
                id: "Pj_Iho1mx2w"
              }
            ]
          }
        },
        {
          id: 11,
          workType: "experiment",
          workTitle: {
            en: "blender practice"
          },
          workInfo: "//3D model",
          workImg: require("@/assets/images/experiment6/0.png"),
          workDetail: {
            info: [
              "Some models and animations made by blender.",
              "",
              "一些用blender做的建模與動畫。",
            ],
            photos: [
              {
                imgs: [
                  {
                    type: "video",
                    data: require("@/assets/images/experiment6/v1.mp4")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "video",
                    data: require("@/assets/images/experiment6/v2.mp4")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "video",
                    data: require("@/assets/images/experiment6/v3.mp4")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "video",
                    data: require("@/assets/images/experiment6/v4.mp4")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/experiment6/0.png")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/experiment6/1.png")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/experiment6/2.png")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/experiment6/3.png")
                  }
                ]
              },
            ]
          }
        },
        {
          id: 12,
          workType: "experiment",
          workTitle: {
            en: "MIDI Guitar"
          },
          workInfo: "//arduino",
          workImg: require("@/assets/images/experiment7/cover.png"),
          workDetail: {
            info: [
              "Tools: Arduino / touch sensor / SoftPot Membrane Potentiometer / electric guitar",
              "",
              "Using membrane potentiometer, touch sensor and Arduino as core, rebuilding broken electric guitar to a MIDI instrument. It can be plug into computer and play with any sound source.",
              "",
              "利用長條形電位器與觸控感測器，以Arduino為核心將廢棄電吉他改造成為MIDI樂器，可連接上電腦套用任何音源進行演奏。",
            ],
            photos: [
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/experiment7/1.png")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/experiment7/2.png")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/experiment7/3.jpg")
                  },
                  {
                    type: "img",
                    data: require("@/assets/images/experiment7/4.jpg")
                  },
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/experiment7/6.png")
                  }
                ]
              },
            ],
            videos: [
              {
                img: require("@/assets/images/experiment7/5.png"),
                id: "bBg9NlOx_WE"
              }
            ]
          }
        },
        {
          id: 13,
          workType: "experiment",
          workTitle: {
            en: "Harmoniser"
          },
          workInfo: "//MaxMSP",
          workImg: require("@/assets/images/experiment8/cover.png"),
          workDetail: {
            info: [
              "Tools: Max/MSP / Novation Launchkey",
              "",
              "Made by Max/MSP. Receive MIDI signal and vocal from mic, and translate MIDI into harmony in realtime, generating the effect of multi vocal chorus.",
              "",
              "使用Max/MSP製作，接收MIDI訊號與麥克風人聲音源輸入，將MIDI即時轉化成為人聲合音，產生出多人合唱的效果。",
            ],
            photos: [
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/experiment8/1.png")
                  }
                ]
              },
            ],
            videos: [
              {
                img: require("@/assets/images/experiment8/cover.png"),
                id: "RlqKrfS9xRw"
              }
            ]
          }
        },
        {
          id: 14,
          workType: "experiment",
          workTitle: {
            en: "Others"
          },
          workInfo: "",
          workImg: require("@/assets/images/experiment9/0.png"),
          workDetail: {
            info: [
              "Design, illustration, video, some random stuffs.",
              "",
              "設計、插畫、錄像，難以歸類的小作品們。",

            ],
            photos: [
              {
                imgs: [
                  {
                    type: "video",
                    data: require("@/assets/images/experiment9/v0.mp4")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/experiment9/1.jpg")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "video",
                    data: require("@/assets/images/experiment9/v1.mp4")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/experiment9/2.jpg")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/experiment9/3.jpg")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/experiment9/4.jpg")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/experiment9/5.jpg")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "video",
                    data: require("@/assets/images/experiment9/v2.mp4")
                  }
                ]
              },
            ]
          }
        },
      ],
      nowWork: {}
    }
  },
  methods: {
    getNowWork: function(){
      if(this.$route.path.split('/').length > 2) {
        let workTitle = this.$route.path.split('/')[2];
        let nowWork = this.works.find(function(work) {
          return work.workTitle.en.toLowerCase().replace(/ /g, '-').replace(/\?/g, '') === workTitle;
        });
        this.nowWork = nowWork;
      }
    }
  },
  mounted() {
    this.getNowWork();
  },
  watch: {
    '$route' () {
      this.getNowWork();
    }
  }
}
</script>

<style lang="sass" scoped>
  #works
    display: flex
    flex-direction: column
    max-width: 900px
    padding: 180px 0
    @media screen and (max-width: 600px)
      padding: 100px 0
      .section-title
        span
          float: left

  .work-list
    width: 100%
    display: flex
    flex-direction: column
    margin-top: 100px
    .link
      width: 100%

</style>



// WEBPACK FOOTER //
// src/components/Experiments.vue